import { Languages } from "../LanguageContext";

const translations = {
  [Languages.English]: {
    offerts: "ogłoszeń",
  },
  [Languages.German]: {
    offerts: "ogłoszeń",
  },
};

export { translations };
